// extracted by mini-css-extract-plugin
export var active = "LanguageSwitch-module--active--c0e86";
export var container = "LanguageSwitch-module--container--b3b0f";